document.addEventListener('DOMContentLoaded', () => {
  const el = document.querySelector('.main-visual .swiper-container')
  if (!el) return

  const controller = document.querySelector('.main-visual__controller')

  const isDesktop = () => window.matchMedia('(min-width: 768px)').matches

  // 모바일은 데이터 절약을 위해 기본적으로 영상을 멈춘 채(포스터 표시) 시작함.
  // 단, autoplay 속성이 붙은 영상(언어별 프로모션 영상 블록)은 모바일에서도 자동재생함.
  const shouldAutoplay = (video) => isDesktop() || video.hasAttribute('autoplay')

  function showPlaying(video, poster, button) {
    if (poster) poster.style.display = 'none'
    button.style.display = 'block'
    button.classList.add('s-playing')
    button.setAttribute('aria-label', 'Pause video')
  }

  function showPaused(video, poster, button) {
    if (poster) poster.style.display = 'block'
    button.style.display = 'block'
    button.classList.remove('s-playing')
    button.setAttribute('aria-label', 'Play video')
  }

  function setupActiveSlide(slide) {
    const video = slide.querySelector('video')
    const poster = slide.querySelector('.main-visual__media--poster')
    const button = slide.querySelector('.main-visual__media--btn')
    if (video && button) {
      if (shouldAutoplay(video)) {
        // iOS 저전력 모드 등으로 브라우저가 자동재생을 막으면 play()가 실패함.
        // 그때는 포스터와 재생 버튼을 보여줘서 직접 누르면 재생되게 함.
        video.muted = true
        const result = video.play()
        if (result && typeof result.then === 'function') {
          result
            .then(() => showPlaying(video, poster, button))
            .catch(() => showPaused(video, poster, button))
        } else {
          showPlaying(video, poster, button)
        }
      } else {
        video.pause()
        showPaused(video, poster, button)
      }
    }
  }

  function updateControllerColor(slide) {
    const colorMode = slide.dataset.colorMode
    if (!controller) return

    const icons = controller.querySelectorAll('i')

    if (colorMode === 'light') {
      controller.classList.add('is-light')
      icons.forEach((icon) => (icon.style.backgroundColor = 'var(--color-gray-100)'))
    } else {
      controller.classList.remove('is-light')
      icons.forEach((icon) => (icon.style.backgroundColor = 'var(--color-gray-000)'))
    }
  }

  const swiper = new Swiper(el, {
    loop: true,
    speed: 600,
    slidesPerView: 1,
    spaceBetween: 0,
    centeredSlides: false,
    pagination: {
      el: '.main-visual__controller-pagination',
      type: 'fraction',
      renderFraction: function (currentClass, totalClass) {
        return (
          '<span class="sr-only">current slide</span>' +
          '<span class="' + currentClass + '"></span>' +
          '<span aria-hidden="true"> / </span>' +
          '<span class="sr-only">total slide</span>' +
          '<span class="' + totalClass + '"></span>'
        )
      },
    },
    navigation: {
      nextEl: '.main-visual__controller-next',
      prevEl: '.main-visual__controller-prev',
    },
    a11y: {
      prevSlideMessage: 'Go to previous slide',
      nextSlideMessage: 'Go to next slide',
      paginationBulletMessage: 'Go to slide {{index}}',
    },
    on: {
      init: function () {
        const activeSlide = this.slides[this.activeIndex]
        setupActiveSlide(activeSlide)
        updateControllerColor(activeSlide)
      },
      slideChange: function () {
        this.slides.forEach((slide) => {
          const video = slide.querySelector('video')
          const poster = slide.querySelector('.main-visual__media--poster')
          const button = slide.querySelector('.main-visual__media--btn')
          if (video) {
            video.pause()
            // video.currentTime = 0
          }
          if (button) {
            button.style.display = 'none'
            button.classList.remove('s-playing')
          }
          // if (poster) {
          //   poster.style.display = 'block'
          // }
        })

        const activeSlide = this.slides[this.activeIndex]
        setupActiveSlide(activeSlide)
        updateControllerColor(activeSlide)
      },
    },
  })

  // 비디오 재생/정지 버튼
  const controlButtons = document.querySelectorAll('.main-visual__media--btn')
  controlButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      event.stopPropagation()
      event.preventDefault()

      const slide = button.closest('.swiper-slide')
      const video = slide.querySelector('video')
      const poster = slide.querySelector('.main-visual__media--poster')

      if (video) {
        if (video.paused) {
          if (poster) poster.style.display = 'none'
          video.play()
          button.classList.add('s-playing')
          button.setAttribute('aria-label', 'Pause video')
        } else {
          video.pause()
          button.classList.remove('s-playing')
          button.setAttribute('aria-label', 'Play video')
        }
      }
    })
  })
})